const FilterIcon: React.FC = () => {
  return (
    <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 2.5H22" stroke="#5C5C5C" strokeLinecap="round" />
      <path d="M1 8.5H22" stroke="#5C5C5C" strokeLinecap="round" />
      <path d="M1 14.5H22" stroke="#5C5C5C" strokeLinecap="round" />
      <circle cx="15.5" cy="14.5" r="2" fill="#F9F9F9" />
      <circle cx="15.5" cy="14.5" r="2" stroke="#F9F9F9" />
      <circle cx="15.5" cy="14.5" r="2" stroke="#5C5C5C" />
      <circle cx="7.5" cy="8.5" r="2" fill="#F9F9F9" />
      <circle cx="7.5" cy="8.5" r="2" stroke="#F9F9F9" />
      <circle cx="7.5" cy="8.5" r="2" stroke="#5C5C5C" />
      <circle cx="15.5" cy="2.5" r="2" fill="#F9F9F9" stroke="#5C5C5C" />
    </svg>
  );
};

export default FilterIcon;
